import { getEnvVar } from "@/common/utils/environment";

export const API_HOST = getEnvVar("VITE_PUBLIC_API_HOST");
